export const TimesheetMasterHeaders = [
  { key: 'employeeName', label: 'Employee Name' },
  { key: 'employeeEmail', label: 'Employee Email' },
  { key: 'date', label: 'Date' },
  { key: 'hoursSpent', label: 'Time Spent' },
  { key: 'isBillable', label: 'Billable' },
  { key: 'managerName', label: 'Manager Name' },
  { key: 'managerEmail', label: 'Manager Email' }
];
